import React, { lazy, Suspense } from "react";
const DecorationLinkSettingsModal = lazy(
  () => import("./../toolbars-modals").then(({ DecorationLinkSettingsModal: DecorationLinkSettingsModal2 }) => ({
    default: DecorationLinkSettingsModal2
  }))
);
const LinkPanelComponent = (props) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", { style: { width: 542, height: 415 } }) }, /* @__PURE__ */ React.createElement(DecorationLinkSettingsModal, { ...props }));
};
var LinkPanelComponent_default = LinkPanelComponent;
export {
  LinkPanelComponent_default as default
};
//# sourceMappingURL=LinkPanelComponent.js.map
